import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import api from "../../services/api";
import { showError, showSuccess } from "../../services/alert";

const RelOperacaoCampo = () => {
  const [safras, setSafras] = useState([]);
  const [safraId, setSafraId] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // 🔹 Carrega as safras no dropdown
  useEffect(() => {
    const loadSafras = async () => {
      try {
        const res = await api.get("/safras");
        setSafras(res.data || []);
      } catch (err) {
        console.error("Erro ao carregar safras:", err);
        showError("Erro ao carregar safras.");
      }
    };
    loadSafras();
  }, []);

  // 🔹 Gera e baixa relatórios autenticados
  const handleDownload = async (tipo) => {
    if (!safraId) {
      showError("Selecione uma safra primeiro.");
      return;
    }

    const url = `/relatorios/operacoes-campo/${safraId}/${tipo}`;
    setLoading(true);

    try {
      // Definição do tipo de resposta
      const responseType =
        tipo === "json" ? "json" : "blob";

      const response = await api.get(url, { responseType });

      // JSON → apenas exibe no console
      if (tipo === "json") {
        console.log("📊 Dados JSON:", response.data);
        showSuccess("JSON carregado no console.");
        return;
      }

      // PDF / CSV → download autenticado
      const blob = new Blob([response.data], {
        type: tipo === "pdf" ? "application/pdf" : "text/csv",
      });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download =
        tipo === "pdf"
          ? `RelatorioOperacoesCampo_${safraId}.pdf`
          : `RelatorioOperacoesCampo_${safraId}.csv`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      showSuccess(
        tipo === "pdf"
          ? "PDF gerado com sucesso."
          : "CSV gerado com sucesso."
      );
    } catch (err) {
      console.error("Erro ao gerar relatório:", err);
      showError("Erro ao gerar relatório.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-4">
      <Header />
      <div className="card shadow-lg border-0 rounded-3">
        {/* 🔹 Cabeçalho */}
        <div className="card-header bg-success text-white d-flex align-items-center gap-3 rounded-top-3">
          {/* Botão voltar */}
          <button
            className="btn btn-light btn-sm d-flex align-items-center gap-1"
            onClick={() => navigate("/menu")}
            disabled={loading}
          >
            <i className="bi bi-arrow-left text-success"></i>
            <span className="text-success fw-semibold">Voltar</span>
          </button>

          <div>
            <h5 className="mb-0">Relatório de Operações de Campo</h5>
            <small className="text-white-50">
              Exporte o histórico de operações por safra
            </small>
          </div>
        </div>

        {/* 🔹 Corpo */}
        <div className="card-body">
          <div className="row g-3 align-items-end">
            {/* Seleção da safra */}
            <div className="col-md-6">
              <label className="form-label fw-semibold">Safra</label>
              <select
                className="form-select rounded-3"
                value={safraId}
                onChange={(e) => setSafraId(e.target.value)}
                disabled={loading}
              >
                <option value="">Selecione...</option>
                {safras.map((s) => (
                  <option key={s.id} value={s.id}>
                    {s.cultura} —{" "}
                    {new Date(s.dataPlantio).toLocaleDateString("pt-BR")}
                  </option>
                ))}
              </select>
            </div>

            {/* Botões de exportação */}
            <div className="col-md-6 d-flex gap-2">
              <button
                className="btn btn-light text-success fw-bold d-flex align-items-center gap-1"
                disabled={loading}
                onClick={() => handleDownload("pdf")}
              >
                <i className="bi bi-file-earmark-pdf"></i>
                <span>PDF</span>
              </button>

              <button
                className="btn btn-light text-success fw-bold d-flex align-items-center gap-1"
                disabled={loading}
                onClick={() => handleDownload("csv")}
              >
                <i className="bi bi-filetype-csv"></i>
                <span>CSV</span>
              </button>

              <button
                className="btn btn-light text-success fw-bold d-flex align-items-center gap-1"
                disabled={loading}
                onClick={() => handleDownload("json")}
              >
                <i className="bi bi-code-slash"></i>
                <span>JSON</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RelOperacaoCampo;
